import { Component, Input } from '@angular/core';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { ResumenDescuentos } from 'src/app/pago/models/ResumenDescuentos.model';

@Component({
  selector: 'app-resumen-compra',
  templateUrl: './resumen-compra.component.html',
  styleUrls: ['./resumen-compra.component.scss'],
})
export class ResumenCompraComponent {
  @Input() configuracionDePago: ConfiguracionDePago;
  @Input() resumenDescuentos: ResumenDescuentos;
}
